import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/lang/i18n'
Vue.config.productionTip = false
// 注册多语言
// import VueI18n from 'vue-i18n';
// // 引入语言资源文件
// import en from '@/lang/en.js';
// import zh from '@/lang/zh.js';
// Vue.use(VueI18n);
// const lang = localStorage.getItem('lang') || 'zh'
// // 创建 VueI18n 实例
// const i18n = new VueI18n({
//   locale: lang, // 默认语言为中文
//   messages: {
//     en: en,
//     zh: zh
//   }
// });
// // 导出 i18n 实例
// export { i18n };
new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
